define('app/models/timer',['app/setup'], function(takhfifan) {
  takhfifan.Timer = Backbone.Model.extend({
    setTimeRemaining: function(remaining) {
      var dd = parseInt(remaining / 86400),
          ss = remaining;
      this.set({seconds: ss, days: dd});

      if (remaining <= 0) {
        ss = dd = 0;
        takhfifan.eventHub.trigger('timeover:' + this.get('dealId'));
      }
    }
  });
});
